'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
// @ts-ignore
import { OverType } from 'overtype';
export function MarkdownEditor(t0) {
  const $ = _c(11);
  const {
    value,
    onChange,
    placeholder,
    minHeight: t1,
    showToolbar
  } = t0;
  const minHeight = t1 === undefined ? 400 : t1;
  const ref = useRef(null);
  const editorRef = useRef(null);
  let t2;
  if ($[0] !== minHeight || $[1] !== onChange || $[2] !== placeholder || $[3] !== showToolbar || $[4] !== value) {
    t2 = () => {
      const [instance] = OverType.init(ref.current, {
        value,
        onChange,
        placeholder,
        minHeight,
        showToolbar
      });
      editorRef.current = instance;
      return () => editorRef.current?.destroy();
    };
    $[0] = minHeight;
    $[1] = onChange;
    $[2] = placeholder;
    $[3] = showToolbar;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== value) {
    t4 = () => {
      if (editorRef.current && value !== editorRef.current.getValue()) {
        editorRef.current.setValue(value);
      }
    };
    t5 = [value];
    $[7] = value;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="overflow-hidden rounded-md border" ref={ref} style={{
      height: "400px"
    }} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}